export const CHECKOUT_PICK_UP_PAYMENT = 'directpayment:DirectPay';
export const CHECKOUT_B2B_PAYMENT = 'directpayment:Invoice';

export const CHECKOUT_KLARNA_SHIPPING = 'DirectShipment:KSS';
export const CHECKOUT_PICK_UP_SHIPPING = 'DirectShipment:PickupAtLocation';
export const CHECKOUT_B2B_SHIPPING = 'DirectShipment:B2BShipping';

export const CHECKOUT_KLARNA_PAYMENT_METHODS = {
  NO: 'klarnapayment:Klarna_NO Checkout',
  SE: 'klarnapayment:Klarna_SE Checkout',
  FI: 'klarnapayment:Klarna_FI Checkout', // TODO: double check this when we integrate FI market
};

export const CHECKOUT_KLARNA_PAYMENT =
  CHECKOUT_KLARNA_PAYMENT_METHODS[window.__litium?.constants?.currentCountry];
